/**
 * Bo+Tee Searchbar — toggles the Figma active/clear state from the input value.
 */
class SearchBar extends HTMLElement {
  /** @type {HTMLInputElement | null} */
  #input = null;

  /** @type {HTMLButtonElement | null} */
  #clear = null;

  connectedCallback() {
    this.#input = this.querySelector('[data-searchbar-input]');
    this.#clear = this.querySelector('[data-searchbar-clear]');
    if (!this.#input || !this.#clear) return;

    this.#input.addEventListener('input', this.#sync);
    this.#clear.addEventListener('click', this.#onClear);
    this.#sync();
  }

  disconnectedCallback() {
    this.#input?.removeEventListener('input', this.#sync);
    this.#clear?.removeEventListener('click', this.#onClear);
    this.#input = null;
    this.#clear = null;
  }

  #sync = () => {
    const hasValue = Boolean(this.#input?.value);
    this.classList.toggle('searchbar--active', hasValue);
    if (this.#clear) this.#clear.hidden = !hasValue;
  };

  syncFromInput() {
    this.#sync();
  }

  /**
   * @param {MouseEvent} event
   */
  #onClear = (event) => {
    event.preventDefault();
    if (!this.#input) return;
    this.#input.value = '';
    this.#input.focus();
    this.#sync();
    this.#input.dispatchEvent(new Event('input', { bubbles: true }));
  };
}

if (!customElements.get('search-bar')) {
  customElements.define('search-bar', SearchBar);
}
